<template>
  <div style="margin-top: 10px">

        <el-form :model="formData" :rules="rules">
          <el-row>
            <el-col  :span="20" >
              <el-form-item label="锯片编号：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.saw_blade_no"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="锯片名称：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="锯片规格：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.model"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="锯片型号：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.model"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="安全库存：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.safety_stock"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="材质：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.material_quality"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="设备类型：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.type"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="净重：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.net_weight"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="毛重：" prop="star" label-width="100px">
                <el-input disabled v-model="formData.gross_weight"></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="20" >
              <el-form-item label="锯片备注：" label-width="100px">
                <el-input disabled v-model="formData.remark" type="textarea" autosize></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="10" >
              <el-form-item label="领取人：" prop="star" label-width="100px">
                <el-input v-model="formData.out_user_name" type="textarea" autosize></el-input>
              </el-form-item>
            </el-col>
            <el-col  :span="20" >
              <el-form-item label="操作备注：" label-width="100px">
                <el-input disabled v-model="formData.operate_remark" type="textarea" autosize></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-button type="primary" style="width: 350px;height:80px;margin-top: 20px;margin-left: 30%;font-size: 30px" @click="addSawBlade" :loading="loading">提交{{this.outTypeName}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

  </div>
</template>

<script>

export default {
  name: "EqSawBladeOutZhiZaoAdd",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scanName: '',
      outTypeName: '',
      formData: {
        saw_blade_no: '',
        name: '',
        model: '',
        remark: '',
        out_type: '',
        out_user_name: '',
        operate_remark: ''
      },
      rules: {
        star: [{required: true, message: '', trigger: 'red'}],
      },
      imageHeight: 300,
      imageWidth: 300,
      printDto: {},
      printImages:[],
      printDtoList:[]
    }
  },
  computed: {

  },
  methods:{

    addSawBlade() {
      this.loading = true
      if (!this.formData.saw_blade_no){
        this.loading = false
        return this.$message.error(`锯片编号不能为空`);
      }
      if (!this.formData.name){
        this.loading = false
        return this.$message.error(`锯片名称不能为空`);
      }
      if (!this.formData.model){
        this.loading = false
        return this.$message.error(`锯片型号不能为空`);
      }
      if (!this.formData.out_user_name){
        this.loading = false
        return this.$message.error(`领用人不能为空`);
      }
      this.formData.out_type = this.parentData.id
      this.$http('eqSawBladeZhiZaoService.addSawBladeOut',this.formData).then(data => {
        this.loading = false
        this.$fn.search();
        this.$fn.closeWindow()
        return this.$message.success('提交成功!');
      }, errMsg => {
        this.loading = false
        return this.$message.error(errMsg);
      })
    },

    getSawBlade() {
      let scanName = {scanName : this.scanName}
      this.$http('eqSawBladeZhiZaoService.getSawBlade',scanName).then(data => {
        this.formData = data
        this.scanName = '';
        return this.$message.success('扫码成功!');
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },

    addKeyboardListener() {
      document.addEventListener('keydown', this.handleKeyDown);
    },

    handleKeyDown(event) {
      if (event.keyCode === 13) {
        if (this.scanName.length !== 0) {
          this.getSawBlade()
        }
      } else if (event.keyCode !== 16) {
        this.scanName += event.key
      }
    },
    removeKeyboardListener() {
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
      // 在组件销毁前执行的生命周期钩子函数
      this.removeKeyboardListener();
    },

  },
  created() {
    this.outTypeName = this.parentData.label
  },
  mounted() {
    // 在组件挂载后执行的生命周期钩子函数
    this.addKeyboardListener();
  },
  beforeUnmount() {
    this.beforeDestroy()
  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 650px;
  margin-left: 80px
}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
.row {
  margin-left: 80px;
  width: 650px;
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
</style>